// The ten English language proficiency documentation types, in display order. Both the
// learner-facing Settings > Documents tab and the admin Student Records tab offer them. Labels come
// from `settings.edit_documents.<type>`.
export const ENGLISH_LANGUAGE_PROFICIENCY_DOCUMENTS_TYPES = [
    'duolingo',
    'toefl_pbt',
    'ibt',
    'ielts',
    'pte',
    'act_compass',
    'accuplacer_esl',
    'eiken',
    'cefr',
    'other',
] as const;
